/**
 * Get an array of all feature flags.
 *
 * @param {Object} state The Redux state.
 * @returns {Object[]}
 */
export default function getFeatureFlags(state) {
  return Object.values(state.featureFlags.items);
}
